// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__Jg3YN","text":"SelectPayment_text__363SP","title":"SelectPayment_title__fNgC7","btn":"SelectPayment_btn__3fTMh"};